import React from 'react';
import { useSelector } from 'react-redux';
import { removeKebabCase } from '@hpi-sox/209150-hpusstore-hpstore-helpers';
import ImageBanner from '../../shared/components/image-banner';

import { getImageBannerContent } from '../../utility/setHtml';

import './blog-cell/css/article-feature-cell.less';

const siteConfigSelector = ({ siteConfig }) => siteConfig && siteConfig.blog && siteConfig.blog.ctaAbtest;

// if the blog has any of these tags, don't display the CTA.
const tagsWithoutCTA = {
    'tech-at-work': 1,
};

function shouldRenderCTA(tags) {
    if (!tags) return true;

    for (let tag of tags) {
        if (tagsWithoutCTA[tag]) return false;
    }

    return true;
}

export default function FeaturedArticleBanner({ tags = [], image, hideCta }) {
    const ctaAbtest = useSelector(siteConfigSelector) || {};
    const isMobile = useSelector(state => state && state.ui && state.ui.width && state.ui.width < 768);
    let { tags: tagsMap, tagsWithoutCTA, ctaLink } = ctaAbtest || {};

    const normalizedTags =
        tags && tags.map(t => removeKebabCase({ str: t }).replace(/\s+/g, '').toLowerCase()).join('');

    const shouldHideCta = isMobile || hideCta || !shouldRenderCTA(tags);

    const ctaLinkKey =
        !shouldHideCta &&
        tagsMap &&
        Object.keys(tagsMap).find(key => {
            return normalizedTags && normalizedTags.indexOf(key) > -1;
        });

    if (ctaLinkKey && tagsMap && tagsMap[ctaLinkKey]) {
        ctaLink = tagsMap[ctaLinkKey];
    }

    const ctaEnabledProps = !shouldHideCta
        ? {
              cta: {
                  href: ctaLink,
                  props: {
                      component: 'ButtonLink',
                      variation: 'primary',
                      color: 'primary',
                      href: ctaLink,
                  },
                  text: 'Buy',
              },
          }
        : {};

    return (
        <ImageBanner
            className={`blogFeaturedBanner${shouldHideCta ? ' blogFeaturedBannerWithoutCta' : ''}`}
            image={{
                alt: image.alt,
                url: {
                    desktop: image.src,
                },
            }}
            {...getImageBannerContent(ctaEnabledProps)}
        />
    );
}
